import React from 'react';
import { Button } from 'antd';

const CustomButton = props => {
  const { children, ...otherProps } = props;

  return <Button {...otherProps}>{children}</Button>;
};

export default CustomButton;
